import request from '@/utils/request'

// 获取基本用户信息
export function getInfo (data) {
  return request({
    url: '/elec/elec/personal/getMyHeadInfo',
    method: 'post',
    data
  })
}

// 注册
export function signup (data) {
  return request({
    url: '/user/signup',
    method: 'post',
    data
  })
}

// 登录
export function signin (data) {
  return request({
    url: '/user/signin',
    method: 'post',
    data
  })
}

export function login (data) {
  return request({
    url: '/customer/app/login',
    method: 'post',
    data
  })
}
